import { P2GBox } from '@parcel2go/core-ui';
import { P2GButton } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { useState } from 'react';
import { ConsignmentApiModel, Dimensions, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { DimensionsSelection } from '../DimensionsSelection';
import { SmartSendItemGroup } from '../item/SmartSendGroup';
import SidePanelSection from '../../../../../components/sidepanel-section';
import { FilterToSendableItems } from '../panels/FilterToSendableItems';
import { CustomInner } from './CustomInner';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

export interface props {
  group: SmartSendItemGroup;
  create: (items: SmartSendItemApiModel[]) => void;
}

export const Custom: React.FC<props> = (props) => {
  const [dims, setDims] = useState<Dimensions>({ ...props.group.Items[0].PackageDimensions });
  const [state, setState] = useState<ConsignmentApiModel>();
  const [valid, setValid] = useState(true);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const create = () => {
    props.create(generateCreate());
  };

  function generateCreate(): SmartSendItemApiModel[] {
    const output: SmartSendItemApiModel[] = [];

    const base = JSON.parse(JSON.stringify(props.group.Items[0])) as SmartSendItemApiModel;

    state.Parcels.forEach((p) => {
      output.push({
        ...base,
        Id: p.Id,
        Source: props.group.Items.find((x) => x.Id === p.Id)?.Source ||
          base.MarketplaceOrderLines.find((m) => m.Id === p.Id)?.Source || { Name: 'Manual', Id: 'manual' },
        MarketplaceOrderLines: p.Orders.map((x) => {
          return base.MarketplaceOrderLines.filter(FilterToSendableItems).find((m) => m.Id === x.Id);
        }).filter((x) => !!x),
        PackageDimensions: { ...dims, ...p.Dimensions }
      } as SmartSendItemApiModel);
    });

    props.group.Items.forEach((x) => {
      if (!output.find((o) => o.Id === x.Id)) {
        output.push({ ...x, MarketplaceOrderLines: [] });
      }
    });

    return output;
  }

  return (
    <>
      <P2GBox mb={3}>
        <P2GText>
          <Trans
            t={t}
            i18nKey="CUSTOMISE_PARCELS_TEXT"
            defaults={`Move the order into the parcels you would like to send. <br />Add and remove as required.`}
          />
        </P2GText>
      </P2GBox>
      <SidePanelSection title={t('SHIPMENT_SUMMARY_SUBTITLE', { defaultValue: 'Shipment Summary' })}>
        <CustomInner
          allowContentChange={false}
          dims={dims}
          allowInlineDimensions={false}
          group={props.group}
          onChange={(i, v) => {
            setState(i);
            setValid(v);
          }}
          itemName="Shipment"
          allowExpanding={false}
          consignment={null}
        />
      </SidePanelSection>
      <SidePanelSection
        title={t('ADDITIONAL_SHIPMENT_DIMENSION_SUBTITLE', { defaultValue: 'Additional Shipment Dimensions' })}
      >
        <DimensionsSelection dimensions={dims} onUpdate={setDims} getPackages={null} startMinimised={false} />
      </SidePanelSection>
      <P2GBox mt={2}>
        <P2GButton disabled={!valid} onClick={create}>
          {t('CONFIRM_CREATE_BUTTON', { defaultValue: 'Confirm and Create' })}
        </P2GButton>
      </P2GBox>
    </>
  );
};
